/* eslint-disable */
export default {
  unmute: 'Desativar mudo',
  mute: 'Ativar mudo',
  keypad: 'Teclado numérico',
  hold: 'Colocar em espera',
  onHold: 'Em espera',
  park: 'Estacionar',
  stopRecord: 'Parar',
  record: 'Gravar',
  add: 'Adicionar',
  transfer: 'Transferir',
  flip: 'Transferência dinâmica',
  more: 'Ações da chamada',
  mergeToConference: 'Mesclar',
  end: 'Encerrar',
  completeTransfer: 'Concluir\na transferência',
} as const;

// @key: @#@"unmute"@#@ @source: @#@"Unmute"@#@
// @key: @#@"mute"@#@ @source: @#@"Mute"@#@
// @key: @#@"keypad"@#@ @source: @#@"Keypad"@#@
// @key: @#@"hold"@#@ @source: @#@"Hold"@#@
// @key: @#@"onHold"@#@ @source: @#@"On Hold"@#@
// @key: @#@"park"@#@ @source: @#@"Park"@#@
// @key: @#@"stopRecord"@#@ @source: @#@"Stop"@#@
// @key: @#@"record"@#@ @source: @#@"Record"@#@
// @key: @#@"add"@#@ @source: @#@"Add"@#@
// @key: @#@"transfer"@#@ @source: @#@"Transfer"@#@
// @key: @#@"flip"@#@ @source: @#@"Flip"@#@
// @key: @#@"more"@#@ @source: @#@"Call Actions"@#@
// @key: @#@"mergeToConference"@#@ @source: @#@"Merge"@#@
// @key: @#@"end"@#@ @source: @#@"End"@#@
// @key: @#@"completeTransfer"@#@ @source: @#@"Complete\nTransfer"@#@
